import React, { ReactElement, ReactNode } from 'react';

export interface MainLayoutBreadcrumbProps {
  children: ReactNode;
}

export const Breadcrumb = ({
  children,
}: MainLayoutBreadcrumbProps): ReactElement => {
  return <>{children}</>;
};
